module.exports = __webpack_public_path__ + "static/img/translation.cd5e907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/secondToolList/translation.png
// module id = +BRf
// module chunks = 3